module.exports = __webpack_public_path__ + "static/img/emotions1_04.eeaabf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/images/emotions1_04.png
// module id = dduu
// module chunks = 0